import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import classnames from 'classnames';

const styles = () => ({
  icon: {},
  progress: {
    fontSize: '20px'
  },
  loadingContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1199, // Just below the main navigation
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.7)'
  }
});

function LoadingIndicator(props) {
  const { classes, fixedPosition } = props;
  const progressStyle = fixedPosition
    ? { position: 'fixed', top: '50%', marginTop: '-20px' }
    : {};
  return (
    <div className={classes.loadingContainer}>
      <CircularProgress
        style={progressStyle}
        className={classnames(classes.progress, classes.icon)}
      />
    </div>
  );
}

LoadingIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
  fixedPosition: PropTypes.bool
};

export default withStyles(styles)(LoadingIndicator);
